import { Components } from '@mui/material/styles';

// ----------------------------------------------------------------------

export function autocomplete(): Components {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: {
          paddingRight: '20px !important',
        },
        input: {
          padding: '6px 0px 12px 12px !important',
        },
      },
    },
  };
}
